
      <!-- TAB BAR  -->

      <div class="tab-bar" [ngClass]="tabBarCssClass">
          <ul #container class="primary-tabs" [class.justify]="secondaryTabs?.length > 0">

              <!--  PRIMARY TABS  -->

              <li *ngFor="let t of primaryTabs">

                  <!--  NON-ROUTE TAB  -->

                  <a #tab
                     *ngIf="!uiTabBar.routeTabs"
                     [attr.id]="tabHash + '_tab_' + t.index"
                     class="tab primary-tab"
                     [class.active]="selectedTabIndex === t.index"
                     (click)="onTabClick(t)">
                      <i class="far fa-check pos-bg pos-fg-col"></i>
                      <span class="text">{{ t.name }}</span>
                  </a>

                  <!--  END NON-ROUTE TAB  -->

                  <!-- ROUTE TAB - NON MODAL  -->

                  <a #tab
                     *ngIf="uiTabBar.routeTabs && !uiTabBar.modalTabs"
                     [attr.id]="tabHash + '_tab_' + t.index"
                     class="tab primary-tab"
                     [routerLink]="[t.path]"
                     routerLinkActive="active">
                      <span class="text">{{ t.name }}</span>
                  </a>

                  <!--  END ROUTE TAB - NON MODAL  -->

                  <!-- ROUTE TAB - MODAL  -->

                  <a #tab
                     *ngIf="uiTabBar.routeTabs && uiTabBar.modalTabs"
                     [attr.id]="tabHash + '_tab_' + t.index"
                     class="tab primary-tab"
                     [class.active]="selectedTabIndex === t.index"
                     (click)="onModalRouteTabClick(t)">
                      <span class="text">{{ t.name }}</span>
                  </a>

                  <!--  END ROUTE TAB - MODAL  -->

              </li>

              <!-- END PRIMARY TABS  -->

              <!--  SECONDARY TABS  -->

              <li *ngIf="secondaryTabs?.length > 0" class="more-tab">

                  <!--  MORE TAB  -->

                  <a [class.expanded]="secondaryTabsPopover.show"
                     (click)="onMoreClick()">
                      <span class="text">More <i class="fas fa-chevron-down"></i></span>
                  </a>

                  <!--  END MORE TAB  -->

                  <!--  SECONDARY TABS POPOVER  -->

                  <ui-popover *ngIf="popoverExists" [uiPopover]="secondaryTabsPopover">

                      <!--  SECONDARY ITEMS  -->

                      <ul class="link-list secondary-tabs">
                          <li *ngFor="let t of secondaryTabs">

                              <!--  NON-ROUTE TAB  -->

                              <a #tab
                                 *ngIf="!uiTabBar.routeTabs"
                                 [attr.id]="tabHash + '_tab_' + t.index"
                                 class="tab"
                                 [class.active]="selectedTabIndex === t.index"
                                 (click)="onTabClick(t)">
                                  <span class="text">{{ t.name }}</span>
                              </a>

                              <!--  END NON-ROUTE TAB  -->

                              <!--  ROUTE TAB  -->

                              <a #tab
                                 *ngIf="uiTabBar.routeTabs"
                                 [attr.id]="tabHash + '_tab_' + t.index"
                                 class="tab"
                                 (click)="setHideMore()"
                                 [routerLink]="[t.path]"
                                 routerLinkActive="active">
                                  <span class="text">{{ t.name }}</span>
                              </a>

                              <!-- END ROUTE TAB  -->

                          </li>
                      </ul>

                      <!-- END SECONDARY ITEMS  -->

                  </ui-popover>

                  <!--  END SECONDARY TABS POPOVER  -->

              </li>

              <!--  END SECONDARY TABS  -->

              <!--  HIGHLIGHT TAB  -->

              <li class="highlight acc-hl-bg"
                  [class.static]="highlightStatic"
                  [style.left]="highlightLeft + 'px'"
                  [style.width]="highlightWidth + 'px'">
              </li>

              <!--  END HIGHLIGHT TAB  -->

          </ul>
      </div>

      <!--  END TAB BAR  -->
    